<template>

  <div class="card">
    <img
      v-if="postType.image"
      :src="postType.image"
      :alt="postType.title"
      class="card-img-top">

    <div class="card-body">
		<h5 v-if="postType.title" class="card-title">
			<a :href="postType.url">
				<span v-html="highlightedPostTitle || postType.title" />
			</a>
		</h5>
		<div v-if="postType.location"
		class="search-location"
		v-html="postType.location" />
		
		<p v-if="postType.excerpt" class="card-text">
			<span v-html="highlightedPostExcerpt || postType.excerpt"/>
		</p>
    </div><!-- .card-body -->

  </div><!-- .card -->

</template>

<script>
export default {
	props: {
		postType: {
			type: Object,
			required: true,
			default: null
		},
		searchTerm: {
			type: String,
			required: false,
			default: null
		}
	},
	computed: {

		// highlight the search term in post titles.
		highlightedPostTitle() {
			if ( this.searchTerm ) {
				return this.highlightData( this.postType.title );
			}
		},

		// highlight the search term in post excerpts.
		highlightedPostExcerpt() {
			if ( this.searchTerm ) {
				return this.highlightData( this.postType.excerpt );
			}
		}
	},
	methods: {

		// add span tags with the hl-search CSS class to the search term.
		highlightData( data ) {
			if ( this.searchTerm ) {
				const pattern = new RegExp( this.searchTerm, 'i' );
				const highlightedData = data.replace(
					pattern,
					`<span class="hl-search">${this.searchTerm}</span>`
				);
				return highlightedData;
			}
		}
	}
};
</script>

<style scoped>
.card {
	min-width: 100%;
	display: flex;
	margin-bottom: 15px;
}
.card-title{
	margin-top: 0px;
}
.card-img-top {
	height: 100px;
    object-fit: cover;
    margin-right: 30px;
}
.card-title a{
    color: #1A2B50;
    text-transform: uppercase;
    font-size: 16px;
    line-height: 26px;
}
.card-text{
	font-size: 14px;
    color: var(--grey-color, #5E6D77);
    font-weight: 400;
}
.card .hl-search {
	background-color: yellow;
}
.search-location .service-location{
	display: flex;
	align-items: center;
}
.search-location .service-location i{
	margin-right: 5px;
}
@media only screen and (max-width: 768px) {
	.card {
		min-width: 50%;
	}
}

@media only screen and (max-width: 480px) {
	.card {
		min-width: 100%;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/AppDisplayPost.vue